export const BUILD_ENV = process.env.BUILD_ENV;
export const NODE_ENV = process.env.NODE_ENV;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const CURRENT_ENV = process.env.REACT_APP_CURRENT_ENV;
export const API_BASE = process.env.REACT_APP_API_BASE;
export const API_SIMPLE = process.env.REACT_APP_API_SIMPLE;
export const CDN_TRANSLATION = process.env.REACT_APP_CDN_TRANSLATION;

export enum Environments {
	PRODUCTION_ENV = 'production',
	STAGING_ENV = 'stage',
	DEVELOPMENT_ENV = 'development',
}

export const DEV_MODE = NODE_ENV === Environments.DEVELOPMENT_ENV;

export const HOSTNAME = window.location.hostname.replace('embed.', '');
export const CLIENT_ID = window.location.pathname.split('/')[2];
export const BASE_PATH_NAME = `${PUBLIC_URL}/${CLIENT_ID}`;

export const BASE_API_URL = DEV_MODE ? API_BASE : `https://${CLIENT_ID}.${HOSTNAME}${API_BASE}`;
export const BASE_URL = DEV_MODE ? API_BASE : `https://${CLIENT_ID}.${HOSTNAME}`;
export const CLIENT_POINT_API_BASE = `client-point.${HOSTNAME}`;
